<template>
  <template v-if="filteredNodes.length > 0">
    <NavTree
      v-for="node in filteredNodes"
      :key="node.layoutStoreKey || node.label"
      :nav="node"
      :search-term="searchTerm"
      :module-label="node.label"
      :is-search-active="!!searchTerm"
      @close="emit('close', $event)"
    />
  </template>
  <template v-else>
    <SCANoItems :title="$t('common.emptyState.empty3')" />
  </template>
</template>

<script setup lang="ts">
import { SCANoItems } from "@scayla/components";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import type { NavNode } from "@/utils/navUtils";
import { nodeMatchesSearch } from "@/utils/navUtils";

import NavTree from "../NavTree.vue";

const { t: $t } = useI18n();

const props = defineProps<{
  nodes: NavNode[];
  searchTerm: string;
}>();

const emit = defineEmits(["close"]);

const lowerSearchTerm = computed(() => props.searchTerm?.toLowerCase() || "");

const filteredNodes = computed(() => {
  if (!props.searchTerm) return props.nodes;

  return props.nodes.filter((node) => nodeMatchesSearch(node, lowerSearchTerm.value));
});
</script>
